<header class="navbar">
  <div class="upper-navbar">
    <div></div>
    <div class="company-header-logo">
      <img class="img-responsive" src="assets/img/logos/utender_icon_blue.png" alt="logo" />
    </div>
    <div class="provided-by">
      <span>provided by</span>
      <img class="img-responsive occon-icon" src="assets/img/logos/occon_logo.png" alt="occon logo"/>
    </div>
    <div></div>
  </div>

  <div class="lower-navbar">
    <div class="title-container">
        {{headerText}}
    </div>
    <div class="language-setting" (click)="menu.toggle($event)">      
      <p-menu #menu [model]="languages" [popup]="true" appendTo="body">
        <ng-template pTemplate="item" let-item>
          <a pRipple class="flex align-items-center px-3 py-2 cursor-pointer">
            <p-avatar 
              [image]="item.routerLink"
              shape="circle" 
              styleClass="lang-img lang-img-small"
            />
            <span class="pl-2">{{item.label}}</span>
          </a>
        </ng-template>
      </p-menu>
      <p-avatar 
        [image]="flagImgSource"
        shape="circle" 
        styleClass="lang-img"
      />
    </div>
  </div>
</header>